import React from "react";

const hasWebGLSupport = () => {
  if (typeof window === "undefined") return false;

  try {
    const canvas = document.createElement("canvas");
    const gl =
      canvas.getContext("webgl2") ||
      canvas.getContext("webgl") ||
      canvas.getContext("experimental-webgl");

    return Boolean(gl);
  } catch (_) {
    return false;
  }
};

class ThreeCanvasBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch() {}

  render() {
    if (this.state.hasError) {
      return this.props.fallback || null;
    }

    return this.props.children;
  }
}

export default function SafeThreeCanvas({ children, fallback = null }) {
  const [enabled, setEnabled] = React.useState(true);

  React.useEffect(() => {
    setEnabled(hasWebGLSupport());
  }, []);

  if (!enabled) {
    return fallback;
  }

  return <ThreeCanvasBoundary fallback={fallback}>{children}</ThreeCanvasBoundary>;
}
